import { render, staticRenderFns } from "./ProcessExcellenceColumnNew.vue?vue&type=template&id=49859c70&scoped=true&"
import script from "./ProcessExcellenceColumnNew.vue?vue&type=script&lang=js&"
export * from "./ProcessExcellenceColumnNew.vue?vue&type=script&lang=js&"
import style0 from "./ProcessExcellenceColumnNew.vue?vue&type=style&index=0&id=49859c70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49859c70",
  null
  
)

export default component.exports